import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "apple-mobile-web-app-capable",
  content: "yes"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("PopCards Camera")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("PopCards Camera")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Open AR Camera", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Click or Tap here to view your collection in real-time Augmented Reality!")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Host Game (Coming Soon)", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Click or Tap here to Host a game!")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Join Game (Coming Soon)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Click or Tap here to scan a Host's QR Code!")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://discord.com/widget?id=900073339018674287&theme=dark",
  width: "100%",
  height: "500",
  allowtransparency: "true",
  frameborder: "0",
  sandbox: "allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Check out this other Popcards Game!", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "A 3D MMORPG Adventure featuring Tilt World, the home of the Popcards enemies!")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Go on an incredibly open world adventure and experience the enemies from the PopCards series in the Massively Online Multiplayer Game, No More Sleep! ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" [ ~ About ~ ] You pass through Bakerville to get one of the best things you can ever eat: a Bakerville Burrito! But suddenly, a wizard puts you to sleep with a magical spell and steals your burrito! You wake up, in your dream, to a huge world known as the MindScape. Among the dreams accessible in the MindScape is a dream called \"Tilt World.\" This world features PopCards Enemies!")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Will you get your burrito back by going on the quest of a lifetime? The choice is in your hands. Tap this window to get started! ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: "https://web.zappar.com/?zid=z/bk6j1c&rs=0&menu=0&toolbar=0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: "https://www.roblox.com/games/5044120541/No-More-Sleep-Pre-Alpha"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}